"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var DATE_INPUT_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return TimePickerMinutesComponent; }),
    multi: true
};
require("./sis-time-picker.component.css");
var TimePickerMinutesComponent = /** @class */ (function () {
    function TimePickerMinutesComponent() {
        this.ampm = false;
        this._time = 0;
        this.focused = null;
    }
    TimePickerMinutesComponent.prototype.ngOnInit = function () {
        this.createTimeOptions(this.ampm, 30);
    };
    //From ControlValueAccessor interface
    TimePickerMinutesComponent.prototype.writeValue = function (time) {
        this._time = time || 0;
    };
    //From ControlValueAccessor interface
    TimePickerMinutesComponent.prototype.registerOnChange = function (callbackFunction) {
        this._onChangeCallback = callbackFunction;
    };
    //From ControlValueAccessor interface
    TimePickerMinutesComponent.prototype.registerOnTouched = function (callbackFunction) {
        this._onTouchedCallback = callbackFunction;
    };
    TimePickerMinutesComponent.prototype.changeTime = function (diff) {
        this.time = this.time + diff;
    };
    Object.defineProperty(TimePickerMinutesComponent.prototype, "time", {
        get: function () {
            return this._time;
        },
        set: function (time) {
            this._time = (time + 1440) % 1440;
            this._onChangeCallback(this._time || 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerMinutesComponent.prototype, "hour", {
        get: function () {
            var h = Math.floor(this.time / 60);
            if (this.ampm) {
                h = h % 12;
                h = h === 0 ? 12 : h;
            }
            return (100 + h).toString().substr(1, 2);
        },
        enumerable: true,
        configurable: true
    });
    TimePickerMinutesComponent.prototype.setHour = function (el) {
        this.setTime(parseInt(el.value, 10) || 0, null, null);
        el.value = this.hour;
    };
    Object.defineProperty(TimePickerMinutesComponent.prototype, "minute", {
        get: function () {
            return (100 + (this.time % 60)).toString().substr(1, 2);
        },
        enumerable: true,
        configurable: true
    });
    TimePickerMinutesComponent.prototype.setMinute = function (el) {
        this.setTime(null, parseInt(el.value, 10) || 0, null);
        el.value = this.minute;
    };
    Object.defineProperty(TimePickerMinutesComponent.prototype, "period", {
        get: function () {
            return this.time < 720 ? 'AM' : 'PM';
        },
        enumerable: true,
        configurable: true
    });
    TimePickerMinutesComponent.prototype.setPeriod = function (el) {
        this.setTime(null, null, (el.value || '').toLowerCase().includes('p'));
        el.value = this.period;
    };
    TimePickerMinutesComponent.prototype.setTime = function (hour, minute, pm) {
        if (hour === void 0) { hour = null; }
        if (pm === void 0) { pm = null; }
        var h = Math.floor(this._time / 60) || 0;
        var m = (this._time % 60) || 0;
        var p = this._time >= 720;
        if (hour !== null) {
            h = this.ampm && hour === 12 ? (p ? 12 : 0) : hour % 24;
        }
        if (minute !== null) {
            m = minute % 60;
        }
        if (pm !== null) {
            h = h % 12 + (pm ? 12 : 0);
        }
        this.time = h * 60 + m;
    };
    TimePickerMinutesComponent.prototype.isFocused = function (focused) {
        if (focused === void 0) { focused = null; }
        this.focused = focused;
    };
    TimePickerMinutesComponent.prototype.onScroll = function (scrollEvent, value) {
        // We getting vertical scroll amount from detail, as deltaY property of wheel event isn't available in Mozilla.
        var verticalScrollAmount = scrollEvent.deltaY || scrollEvent.detail;
        this.changeTime(verticalScrollAmount > 0 ? -value : value);
    };
    TimePickerMinutesComponent.prototype.createTimeOptions = function (ampm, step) {
        this.timeOptions = [];
        for (var i = 0; i < 1440; i += step) {
            var t = ampm ? i % 720 : i;
            var h = Math.floor(t / 60);
            var m = t % 60;
            h = ampm && h === 0 ? 12 : h;
            this.timeOptions.push({
                label: Math.floor(h + 100).toString().substr(1, 2) + ':' + (m + 100).toString().substr(1, 2) + (ampm ? (i < 720 ? ' AM' : ' PM') : ''),
                value: i
            });
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TimePickerMinutesComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TimePickerMinutesComponent.prototype, "ampm", void 0);
    TimePickerMinutesComponent = __decorate([
        core_1.Component({
            
            selector: "sis-time-picker-minutes",
            template: require('./sis-time-picker-minutes.component.html'),
            providers: [DATE_INPUT_VALUE_ACCESSOR]
        })
    ], TimePickerMinutesComponent);
    return TimePickerMinutesComponent;
}());
exports.TimePickerMinutesComponent = TimePickerMinutesComponent;
//# sourceMappingURL=sis-time-picker-minutes.component.js.map